import AdminLayout from "../../components/Layout/AdminLayout";

import moment from "moment";
import "moment/locale/ko";
import { useNavigate, useParams } from "react-router-dom";
import ScheduleExcel from "../../components/ScheduleExcel";
import { useUserStore } from "../../store";
import { canViewScheduleDate } from "../../libs/scheduleAccess";
import MobilePreviewFrame from "../../components/MobilePreviewFrame";

export default function ScheduleMobilePreview() {
  const { date } = useParams();
  const navigate = useNavigate();

  //--> admin/system 외에는 오늘부터 1주일치만. 지난 수업과 그 이후는 막는다.
  const loginUser = useUserStore((state) => state.user);
  const canView = canViewScheduleDate(loginUser, date);

  const onBackBtn = () => {
    navigate(`/admin/schedule`);
  };

  return (
    <AdminLayout>
      <div className="">
        <div className="mb-2 flex space-x-3">
          <h1
            onClick={onBackBtn}
            className="text-gray-800 font-bold text-base cursor-pointer"
          >
            일별 프로그램 관리
          </h1>
          <h1 className="text-gray-800 font-bold text-base">-</h1>
          <h1 className="text-gray-800 font-bold text-base">
            {moment(date, "YYYY-MM-DD").format("YYYY-MM-DD (ddd)")}
          </h1>
        </div>

        {!canView ? (
          <div className="rounded-lg border border-dashed bg-white py-20 text-center text-sm text-gray-500">
            열람할 수 있는 기간이 아닙니다. 오늘부터 1주일치만 볼 수 있습니다.
          </div>
        ) : (
        <>
        <MobilePreviewFrame>
          <ScheduleExcel mobileView />
        </MobilePreviewFrame>

        </>
        )}
      </div>
    </AdminLayout>
  );
}
